'use client';

import { useState, useEffect } from 'react';

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Button erscheint nach 400 Pixeln Scrollweg
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  // Wir geben den Button immer zurück, steuern aber die Sichtbarkeit über die CSS-Klasse
  return (
    <button 
      onClick={scrollToTop} 
      className={`back-to-top ${isVisible ? 'show' : ''}`}
      aria-label="Nach oben scrollen"
    >
      ↑
    </button>
  );
}